import { createBrowserRouter } from 'react-router';
import { AppShell } from '@/components/shell/AppShell';
import { LoginPage } from '@/features/login/LoginPage';
import { MatterHubPage } from '@/features/matter/MatterHubPage';
import { PipelinePage } from '@/features/pipeline/PipelinePage';
import { QaPage } from '@/features/qa/QaPage';
import { DoctorListPage } from '@/features/registry/DoctorListPage';
import { DoctorPage } from '@/features/registry/DoctorPage';
import { ClinicsPage } from '@/features/registry/ClinicsPage';
import { PracticePage } from '@/features/registry/PracticePage';
import { ReferrersPage } from '@/features/registry/ReferrersPage';
import { BaseEditorPage } from '@/features/registry/templates/BaseEditorPage';
import { OverlayEditorPage } from '@/features/registry/templates/OverlayEditorPage';
import { TemplatesPage } from '@/features/registry/templates/TemplatesPage';
import { WorkspacePage } from '@/features/workspace/WorkspacePage';
import { ClinicPage } from '@/features/clinic/ClinicPage';
import { DoctorHomePage } from '@/features/dr/DoctorHomePage';
import { NotFoundPage, PersonaHomeRedirect } from '@/features/shell/pages';

/**
 * Library-mode routing. Screens arrive milestone by milestone; a route that
 * does not exist yet renders an honest placeholder rather than a 404, so the
 * persona homes always resolve.
 */
export const router = createBrowserRouter([
  { path: '/login', element: <LoginPage /> },
  {
    element: <AppShell />,
    children: [
      { index: true, element: <PersonaHomeRedirect /> },
      { path: 'pipeline', element: <PipelinePage /> },
      { path: 'matters/:ref', element: <MatterHubPage /> },
      { path: 'matters/:ref/workspace', element: <WorkspacePage /> },
      { path: 'qa', element: <QaPage /> },
      { path: 'dr', element: <DoctorHomePage /> },
      { path: 'clinic', element: <ClinicPage /> },
      { path: 'registry', element: <DoctorListPage /> },
      { path: 'registry/doctors', element: <DoctorListPage /> },
      { path: 'registry/doctors/:slug', element: <DoctorPage /> },
      { path: 'registry/referrers', element: <ReferrersPage /> },
      { path: 'registry/clinics', element: <ClinicsPage /> },
      { path: 'registry/practice', element: <PracticePage /> },
      { path: 'registry/templates', element: <TemplatesPage /> },
      { path: 'registry/templates/:type', element: <BaseEditorPage /> },
      { path: 'registry/templates/:type/doctors/:slug', element: <OverlayEditorPage /> },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
]);
